import gql from 'graphql-tag';

export const GET_TICKET = gql`
  query GetTicket($id: Int!, $eventAttendeeId: Int!) {
    ticket(id: $id, eventAttendeeId: $eventAttendeeId) {
      ticket {
        id
        firstName
        lastName
        email
      }
    }
  }
`;
